import { useState } from 'react';
import { CardDescription } from '../ui/card';
import { Button } from '../ui/button';

interface AssignmentCardDescriptionProps {
  description?: string;
  maxLength?: number;
}

export function AssignmentCardDescription({
  description = '',
  maxLength = 150,
}: AssignmentCardDescriptionProps) {
  const [expanded, setExpanded] = useState(false);

  const isLong = description.length > maxLength;
  const displayText = expanded
    ? description
    : description.slice(0, maxLength) + (isLong ? '...' : '');

  return (
    <div className='mb-4 text-left'>
      <CardDescription className='mb-2'>{displayText}</CardDescription>

      {isLong && (
        <Button
          variant='outline'
          size='sm'
          className='p-2 text-sm text-primary'
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
}
